export const getAlertListApi = (leaseId) => {
    return `/alerts/modules/?lease_id=${leaseId}`
}

export const getFleetAlertListApi = (leaseId) => {
    return `/alerts/modules/?lessor_id=${leaseId}`
}

export const getUserApi = (moduleKey,operationKey)=>{
    return `/users/contracts/${moduleKey}/?operation=${operationKey}&sparta_users=true`;
}

export const eventToggleApi = (eventId) => {
    return `/alerts/alert-event-types/${eventId}/recipients/operation/`;
}

export const mailTemplateApi = (eventId) => {
    return `/alerts/email-templates/${eventId}/`;
}

export const updateUserApi = (eventId) => {
    return `/alerts/alert-event-types/${eventId}/recipients/sync/`;
};

export const getCustomAlertApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/alerts/custom-alerts/${queryString ? `?${queryString}` : ""}`;
};

export const addCustomAlertApi = (params) => {
    return `lease/${params?.leaseSlug}/alerts/custom-alerts/`;
}

export const updateCustomAlertApi = (params) => {
    return `lease/${params?.leaseSlug}/alerts/custom-alerts/${params?.slug}/`;
};

export const deleteCustomAlertApi = (params) => {
    return `lease/${params}/alerts/custom-alerts/`;
};

export const getExpiryAlertApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/alerts/expiry-alerts/${queryString ? `?${queryString}` : ""}`;
};

export const addExpiryAlertApi = (params) => {
    return `lease/${params?.leaseSlug}/alerts/expiry-alerts/`;
}

export const updateExpiryAlertApi = (params) => {
    return `lease/${params?.leaseSlug}/alerts/expiry-alerts/${params?.slug}/`;
};

export const deleteExpiryAlertApi = (params) => {
    return `lease/${params}/alerts/expiry-alerts/`;
};